export const DS_TEXTAREA_CLASSES = {
  Root: "ds-textarea",
  Input: "ds-textarea__input",
} as const;
